module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/bg_title-cf7c71349ebd067fa11b5915c69dd550.png";